<template>
  <div class="main">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'Main2',
  data () {
    return {
      msg: 'ここはメイン２です'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  color: black;
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Main2.vue